import { Head, useForm } from "@inertiajs/react";
import { SubmitEvent } from "react";
import { ManagedTrack, SeasonFormData } from "@/types/shared";
import SeasonForm from "./_form";

interface Props {
  tracks: ManagedTrack[];
  errors?: string[];
}

export default function NewSeason({ tracks, errors }: Props) {
  const defaultTrackId = tracks.length === 1 ? tracks[0].id.toString() : "";

  const { data, setData, post, processing } = useForm<SeasonFormData>({
    season: {
      track_id: defaultTrackId,
      name: "",
      slug: "",
      start_date: "",
      end_date: "",
      title_sponsor: "",
      accent_color: "",
      rules_url: "",
      status: "draft",
      description: "",
      poster: null,
      remove_poster: false,
    },
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    post("/track_manager/seasons");
  };

  return (
    <div className="flex">
      <Head title="New Season" />
      <div className="grow">
        <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
          <SeasonForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            tracks={tracks}
            title="New Season"
            submitLabel="Create Season"
          />
        </div>
      </div>
    </div>
  );
}
